var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0455 24.0591C1.64166 24.0591 0.5 23.0092 0.5 21.7181L0.500002 7.67234C0.500002 6.3813 1.64166 5.33137 3.04551 5.33137L16.7003 5.33137L14.1547 7.67234L3.04551 7.67234L3.04551 21.7181L23.4095 21.7181L23.4071 11.5038L25.955 9.16287L25.955 21.7181C25.955 23.0092 24.8134 24.0591 23.4095 24.0591L3.0455 24.0591ZM14.5003 13.5247L14.5003 10.6648L22.5072 3.30132L25.617 6.16351L17.6101 13.5247L14.5003 13.5247ZM26.7182 5.15077L23.6059 2.28858L25.1621 0.859769C25.4663 0.580023 25.9579 0.580023 26.2608 0.859769L28.2719 2.70922C28.576 2.98897 28.576 3.4411 28.2719 3.71968L26.7182 5.15077Z",
    fill: "#F5F6F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.859309fe2641b0c672ad2554ae03a269.svg";
export { ForwardRef as ReactComponent };